<template>
    <div class="site">
        <div class="main-body">
            <section class="hero">
                <a
                    v-if="accounts_entity_id || subDomain === ''"
                    :href="seller_website"
                    target="_blank"
                >
                    <img
                        :src="logo"
                        :alt="logo ? subDomain : ''"
                    />
                </a>
            </section>

            <section class="main-content">
                <span
                    v-if="accounts_entity_id || subDomain === ''"
                    class="tracking-info"
                >
                    <Form
                        @display-track="displayTrack"
                        :hidden="hidden"
                        class="container"
                        :entity-id="accounts_entity_id"
                    />
                    <TrackingDetails
                        v-if="trackingData"
                        :hidden="!hidden"
                        :trackingData="trackingData"
                        @trackMore="showForm"
                    />
                </span>

                <div class="products">
                    <h2 v-if="upsell">More from the seller</h2>
                    <div class=" product-box">
                        <div
                            class="product-card"
                            v-for="product in products.slice(0, 4)"
                            :key="product.id"
                        >
                            <ProductCard :product="product.product_info" />
                        </div>
                    </div>
                </div>

                <div
                    v-if="accounts_entity_id === null && subDomain !== ''"
                    class="section"
                >
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">Whoops!!!</p>
                            <a
                                href="#"
                                class="card-header-icon"
                                aria-label="more options"
                            >
                                <span class="icon">
                                    <i
                                        class="fas fa-angle-down"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <p>
                                    Your sub-domain doesn't exist, have you
                                    registered it in your personalization tab?
                                </p>
                                <p>
                                    <a
                                        target="_blank"
                                        :href="personalizationUrl"
                                        >Click here</a
                                    >
                                    to get your own custom tracking sub domain.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <footer>
            <div class="bottom">
                <div
                    v-if="this.seller_email && this.seller_contact"
                    class="seller-contact"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="footer-icon"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                        />
                    </svg>

                    <p>{{ this.seller_email }}</p>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="footer-icon"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                        />
                    </svg>
                    <p>{{ this.seller_contact }}</p>
                </div>
                <div class="powered-by">
                    <p>Powered by &nbsp;&nbsp;</p>
                    <a href="https://www.vamaship.com">
                        <img
                            :src="vamashipLogo"
                            alt="Vamaship Logo"
                            class="image vamaship-logo"
                        />
                    </a>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import Form from "./components/Form";
import TrackingDetails from "./components/TrackingDetails";
import ProductCard from "./components/ProductCard.vue";
export default {
    components: {
        Form,
        TrackingDetails,
        ProductCard
    },
    name: "App",
    data() {
        return {
            hidden: false,
            trackingData: null,
            estimatedDelivery: null,
            accounts_entity_id: undefined,
            logo:
                "https://ps.w.org/vamaship-shipping/assets/icon-256x256.png?rev=2106211",
            mode: "light",
            products: [],
            upsell: false,
            vamashipLogo: require("./assets/vamaship_logo.png"),
            seller_email: "",
            seller_contact: "",
            seller_website: ""
        };
    },

    mounted() {
        this.getLogo();
    },

    computed: {
        personalizationUrl() {
            return "https://app.vamaship.com/personalize?tabLevel1=custom-tracking";
        },
        subDomain() {
            let hostname = window.location.hostname;
            if (hostname.includes("www.")) {
                hostname = hostname.replace("www.", "");
            }
            if (!hostname.includes(".")) {
                return null;
            }
            return hostname.replace("vamaship.co", "").replace(".", "");
        }
    },

    methods: {
        showForm() {
            this.hidden = false;
        },

        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        async getLogo() {
            let subDomain = this.subDomain;
            if (process.env.NODE_ENV === "development") {
                subDomain = "slugfest";
            }

            if (!subDomain) {
                this.accounts_entity_id = null;
                return;
            }

            const url = `${process.env.VUE_APP_ACCOUNTS_URL}/entities/${subDomain}/get-logo-from-slug`;
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    const responseErrors = await response.json();
                    console.log(responseErrors["errors"]);
                    return;
                }
                const data = await response.json();
                this.logo = data.data["entity_logo"];
                this.accounts_entity_id = data.data["accounts_entity_id"];
                this.getProducts();
            } catch (error) {
                console.log(error);
                this.accounts_entity_id = null;
            }
        },

        async getProducts() { const url = `${process.env.VUE_APP_E3_URL}/entities/upsell/${this.accounts_entity_id}`;
            try {
                const response = await fetch(url);
                const { data } = await response.json();
                this.products = data.products;

                if (this.products.length > 0) {
                    this.upsell = true;
                }
            } catch (err) {
                console.log(err);
            }
        },
        displayTrack(trackingData) {
            const orderTracking = this.groupByShipmentNo(trackingData.data);
            const trackingIds = trackingData.tracking_ids;
            const trackingIdType = trackingData.tracking_id_type;

            this.setShipmentNos(trackingIds, trackingIdType);
            this.hidden = true;
            this.trackingData = orderTracking;
        },

        setShipmentNos(trackingIds, trackingIdType) {
            if (history.pushState) {
                let searchParams = new URLSearchParams(window.location.search);
                searchParams.set("tracking_ids", trackingIds);
                searchParams.set("tracking_id_type", trackingIdType);
                let newUrl =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?" +
                    searchParams.toString();
                window.history.pushState(
                    {
                        path: newUrl
                    },
                    "",
                    newUrl
                );
            }
        },

        groupByShipmentNo(trackingData) {
            const data = {};
            let estimatedDeliveryTimeline = {};

            console.log(trackingData);
            trackingData.tracking_details.forEach((t, i) => {
                estimatedDeliveryTimeline[t] = null;
                if (trackingData.estimated_delivery[t.shipment_no] !== undefined) {
                  estimatedDeliveryTimeline[t.shipment_no] = this.convertDateToIST(trackingData.estimated_delivery[t.shipment_no].estimated_delivery_date);
                }

                if (data.hasOwnProperty(t.shipment_no)) {
                    data[t.shipment_no]["trackings"].push({
                        location: t.location,
                        comment: t.comment || "-",
                        date: this.convertDateToIST(t.event_date),
                        status: t.status_message,
                        status_code: t.tracking_status
                    });
                    return;
                }
                data[t.shipment_no] = {
                    shipment_no: t.shipment_no,
                    awb_no: t.awb_no || "-",
                    order_id: t.order_id || "-",
                    origin: t.origin_pincode,
                    destination: t.destination_pincode,

                    origin_city: t.origin_city,
                    destination_city: t.destination_city,

                    current_status: t.status_message,
                    current_status_code: t.tracking_status,
                    current_status_date_time: this.convertDateToIST(
                        t.event_date
                    ),

                    product: t.product,
                    product_code: t.product_code,
                    partner: t.partner_name,
                    partner_logo: t.partner_logo,
                    shipment_zone: t.shipment_zone,
                    shipment_date: t.shipment_date,

                    partner_tracking_url: t.supplier_tracking_url
                        ? t.supplier_tracking_url.replace(
                              "<tracking_id>",
                              t.awb_no
                          )
                        : null,
                    estimated_delivery_timeline:
                        estimatedDeliveryTimeline[t.shipment_no],
                    trackings: [
                        {
                            location: t.location,
                            comment: t.comment || "-",
                            date: this.convertDateToIST(t.event_date),
                            status: t.status_message,
                            status_code: t.tracking_status
                        }
                    ]
                };
                this.seller_email = t.seller_email;
                this.seller_contact = `${t.seller_calling_code} ${t.seller_contact}`;
                this.seller_website = t.seller_website;
            });

            return data;
        },
        convertDateToIST(date) {
            if (!date) {
                return "";
            }
            date = date.replace(/\s/, "T");
            date = new Date(date);
            // date.setHours(date.getHours() + 5);
            // date.setMinutes(date.getMinutes() + 30);
            return date;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/App.vue